import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BrandPhoto } from './components/BrandPhoto';
import { AppShowcase } from './components/AppShowcase';
import { WhatYouFind } from './components/WhatYouFind';
import { TakeawaysSection } from './components/TakeawaysSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-full bg-cream font-sans antialiased" data-id="element-0" data-mp="2wi5l9cv6edmo">
      <noscript data-id="element-1" data-mp="28surifc8tji1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="28sbad0uf2z52" />
      </noscript>
      <Header data-id="element-3" data-mp="3mlavl1vse5rc" />
      <main data-id="element-4" data-mp="3ml17jjuay8oa">
        <Hero data-id="element-5" data-mp="3mkhn9wh6j873" />
        <BrandPhoto data-id="element-6" data-mp="3mjzsl4a6121a" />
        <AppShowcase data-id="element-7" data-mp="3mjg8bgx1m1k3" />
        <WhatYouFind data-id="element-8" data-mp="3rc9hqi3ghy2i" />
        <TakeawaysSection data-id="element-9" data-mp="3rbzmaezn6ypf" />
        <PricingSection data-id="element-10" data-mp="3rcsy3udgkeef" />
        <GuaranteeSection data-id="element-11" data-mp="3recbnd7qcbci" />
        <FaqSection data-id="element-12" data-mp="5os92t1uy7l" />
        <ClosingSection data-id="element-13" data-mp="4wvvprmowg9" />
      </main>
      <Footer data-id="element-14" data-mp="56qxrrj5tst" />
    </div>;
}